import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Expo } from 'gsap'

import YouTube from 'react-youtube'

import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'
import components from 'src/utils/components'

export default class Player extends Component {
  constructor(props) {
    super(props)

    this.key = `player`
    this.player = {}
    this.state = { idYt: this.props.idYt }
  }

  componentDidMount() {
    this.initTL()
    this.onResize()

    resize.add(this.onResize, this.key)
  }

  componentWillUnMount() {
    raf.remove(this.raf)
    resize.remove(this.onResize)
  }

  initTL() {
    this.tlAnimateIn = new TimelineMax({
      paused: true,
      onComplete: () => {
        this.playerIsVisible = true
        this.video && this.video.playVideo()
      },
      onReverseComplete: () => {
        this.video && this.video.stopVideo()
      }
    })

    this.tlAnimateIn
      .fromTo(
        this.refs.component,
        0.8,
        {
          y: '100%'
        },
        {
          y: '0%',
          ease: Expo.easeIn
        },
        0
      )
      .fromTo(
        this.refs.overlay,
        0.8,
        {
          y: '0%'
        },
        {
          y: '-100%',
          ease: Expo.easeOut
        },
        0.8
      )
      .fromTo(
        this.refs.mainWrapper,
        0.8,
        {
          y: 200,
          autoAlpha: 0
        },
        {
          y: 0,
          autoAlpha: 1,
          ease: Expo.easeOut
        },
        0.8
      )

    this.tlAnimateClose = new TimelineMax({
      paused: true,
      onComplete: () => {
        this.video && this.video.playVideo()
        this.playerIsVisible = true
      }
    })

    this.tlAnimateClose
      .to(
        this.refs.rotateTop,
        0.6,
        {
          rotation: 135,
          ease: Expo.easeOut
        },
        0
      )
      .to(
        this.refs.rotateBtm,
        0.6,
        {
          rotation: 45,
          ease: Expo.easeOut
        },
        0.1
      )
  }

  animateIn(id) {
    if (this.tlAnimateIn.progress() > 0) return

    id && id != this.props.ytCover && this.setState({ idYt: id })

    this.video && this.video.playVideo()
    this.tlAnimateIn.play(0)
  }

  onResize = () => {
    const $component = this.refs.component.getBoundingClientRect()

    this.topComponent = $component.top + values.scroll.currentY
    this.yOffset =
      this.topComponent < values.viewport.height
        ? this.topComponent
        : this.topComponent - values.viewport.height

    this.xOffset = $component.left
    this.hComponent = this.refs.component.offsetHeight
    this.wComponent = this.refs.component.offsetWidth

    setTimeout(this.addToMenu, 1)
  }

  _onReady = e => {
    if (!this.video) {
      this.video = e.target
    }
  }

  onMouseEnterClose = () => {
    this.tlAnimateClose.play()
  }

  onMouseLeaveClose = () => {
    this.tlAnimateClose.reverse()
  }

  onClickClose = () => {
    this.video && this.video.pauseVideo()
    this.tlAnimateIn.reverse()
  }

  render() {
    const opts = {
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 0,
        rel: 0,
        showinfo: 0,
        showsearch: 0,
        modestbranding: 1,
        iv_load_policy: 3,
        color: 'white',
        playsinline: 1,
        fs: 0
      }
    }

    return (
      <div ref="component" className="component player-video">
        <span ref="overlay" className="overlay" />
        <span
          onMouseEnter={this.onMouseEnterClose}
          onMouseLeave={this.onMouseLeaveClose}
          onClick={this.onClickClose}
          ref="close"
          className="close">
          <span ref="rotateTop" className="line rotate-top" />
          <span ref="rotateBtm" className="line rotate-btm" />
        </span>
        <div ref="mainWrapper" className="main-wrapper">
          <YouTube
            ref="yt"
            containerClassName="yt-container-player"
            className="yt-player"
            videoId={this.state.idYt}
            opts={opts}
            onReady={this._onReady}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/player/index.js